module.exports = __webpack_public_path__ + "static/media/vf_mjumper_core.98eb8c23.svg";